import { render } from "./RoleScreen.vue?vue&type=template&id=638a352c&scoped=true"
import script from "./RoleScreen.vue?vue&type=script&lang=js"
export * from "./RoleScreen.vue?vue&type=script&lang=js"

import "./RoleScreen.vue?vue&type=style&index=0&id=638a352c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-638a352c"]])

export default __exports__